const clubModalTools = {
    openModal: function(button) {
        let type = button.attr('data-type')
        let wrapper = button.closest('.js_club-modal__main')
        wrapper.removeClass('active')
        wrapper.siblings(`[data-type=${type}]`).addClass('active')
    },

    closeModal: function(button) {
        if (button) {
            button.closest('.js_club-modal').removeClass('active')
            $('.js_club-modal__main').removeClass('active')
            $('.js_club-modal__main[data-type=main]').addClass('active')
            if (button.closest('.js_club-modal').attr('data-reload') == 'true') {
                window.location.reload()
            }
        } else {
            $('.js_club-modal').removeClass('active')
            $('.js_club-modal__main').removeClass('active')
            $('.js_club-modal__main[data-type=main]').addClass('active')
        }
    }
}

window.clubModalTools = clubModalTools

$(document).on('click', '.js_club-modal__close', function() {
    clubModalTools.closeModal($(this))
})

$(document).on('click', '.js_club-modal__main-btn', function() {
    clubModalTools.openModal($(this))
})